import { BatchSpanProcessor } from '@opentelemetry/sdk-trace-base';
import {
  getENV,
  getStaticApiKey,
  GLOBALS,
  NODE_ENVIRONMENTS
} from 'services/globals';
import {
  Instrumentations,
  Match,
  NitroFetchInstrumentation,
  OpenTelemetryManager,
  SpanRegistrar
} from '@trp-ta-nitro/otel-browser-js';

import Exporter from 'services/Observability/Exporter';
import { withTrailingSlash } from '../Externals';

export const appName = 'app10422:account-access-ui:' + getENV().toLowerCase();
export let otelManager = null;
export let spanRegistrar = new SpanRegistrar();
export let tracer = null;

export const restSpanProcessor = () => {
  const apiKey = window?.config?.apiKey || getStaticApiKey();
  const httpExporter = new Exporter({
    headers: {
      apikey: apiKey,
      'trp-request-consumer-initial': 'account-access-ui-otel',
      'X-TRP-Requested-With': 'otel',
      credentials: 'include',
      'Content-Type': 'application/json'
    },
    url: `${
      getENV() === NODE_ENVIRONMENTS.LOCAL
        ? withTrailingSlash(GLOBALS.AAM_UI_TRP_APP_CONTEXT)
        : withTrailingSlash(GLOBALS.AAM_BFF_BASE_URL)
    }api/otel`
  });
  return new BatchSpanProcessor(httpExporter);
};

export const initOpenTelemetry = () => {
  const instrumentation = new NitroFetchInstrumentation({
    // enable traceparent for all outgoing fetches...
    propagateTraceHeaderCorsUrls: [/.+account-access-service\/v4\/api*/],
    // ...except those that disallow it via CORS

    propagateTraceHeaderCorsUrlsBlacklist: [
      Match.UrlPathEquals('/v0/ciam-public/me'),
      Match.UrlPathEquals(
        '/architecture-reference-implementations_echo-oauth-token/echo'
      )
    ],
    ignoreUrls: [
      /.+account-access-service\/v4\/api\/otel*/,
      /.+usis\/my-accounts\/api\/otel*/,
      /.+https:\/\/trp-app.quantummetric.com*/,
      /.+cdn.cookielaw.org*/
    ],
    ignoreNetworkEvents: true
  });
  const manager = new OpenTelemetryManager({ appName })
    .withResourceAttributes({
      // these are values utilized by the trace-derived metrics for their labels
      AppId: 'app10422',
      AppName: 'account-access-ui',
      env: getENV().toLowerCase()
    })
    .withoutInstrumentation(Instrumentations.Fetch)
    .withInstrumentation(() => instrumentation)
    .withSpanProcessor(restSpanProcessor())
    .start();

  tracer = manager.newTracer(appName);
  otelManager = manager;
  return manager;
};

export const getTracer = () => {
  if (tracer) {
    return tracer;
  }
  if (!tracer && otelManager) {
    return otelManager.newTracer(appName);
  }
  if (!tracer && !otelManager) {
    initOpenTelemetry();
    return tracer;
  }
  return tracer;
};

export const getGlobalSpanRegistrar = () => {
  if (!spanRegistrar) {
    spanRegistrar = new SpanRegistrar();
  } else {
    return spanRegistrar;
  }
};
export const getAppName = () => {
  return appName;
};
